<div class="page-innder-body portlet light " [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">
  <div class="portlet-body">
    <!-- First row -->
    <div class="row mt-3 dsKPI">
      <!-- First Card -->
      <div class="col-md-2">
        <div class="card border-primary rounded shadow">
          <div class="card-body d-flex flex-column">
            <span>
              <i class="fa fa-shopping-cart text-primary"></i> {{ 'galleryDashboard.artists' | transloco }}
            </span>
            <div class="mt-2">
              <div class="fw-bold">
                <span>{{galleryDashboardData.TotalConnectedArtist}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Second Card -->
      <div class="col-md-2">
        <div class="card border-primary rounded shadow">
          <div class="card-body d-flex flex-column">
            <span>
              <i class="fa fa-shopping-cart text-danger"></i> {{ 'galleryDashboard.artworks' | transloco }}
            </span>
            <div class="mt-2">
              <div class="fw-bold">
                {{galleryDashboardData.TotatUnSoldArtWorks }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Third Card -->
      <div class="col-md-2">
        <div class="card border-success rounded shadow">
          <div class="card-body d-flex flex-column">
            <span>
              <i class="fa fa-shopping-cart text-success"></i> {{ 'galleryDashboard.artworkValue' | transloco }}
            </span>
            <div class="mt-2">
              <div class="fw-bold">
                <span class="text-primary">{{galleryDashboardData.TotalValueOfUnSoldArtworks |
                currency:'USD':'symbol':'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fourth Card -->
      <div class="col-md-2">
        <div class="card border-warning rounded shadow">
          <div class="card-body d-flex flex-column">
            <span class="mb-1">
              <i class="fa fa-shopping-cart text-danger"></i> {{ 'galleryDashboard.itemSold' | transloco }}
            </span>
            <div>
              <div class="fw-semibold">
                {{ 'galleryDashboard.month' | transloco }}<span class="ms-2">{{galleryDashboardData.ItemsSoldThisMonth}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fifth Card -->
      <div class="col-md-2">
        <div class="card border-info rounded shadow">
          <div class="card-body d-flex flex-column">
            <span class="mb-1">
              <i class="fa fa-briefcase text-warning"></i> {{ 'galleryDashboard.salesValue' | transloco }}
            </span>
            <div>
              <div class="fw-semibold">
                {{ 'galleryDashboard.month' | transloco }} {{galleryDashboardData.SalesValueThisMonth | currency:'USD':'symbol':'1.2-2' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sixth Card -->
      <div class="col-md-2">
        <div class="card border-info rounded shadow">
          <div class="card-body d-flex flex-column">
            <span class="mb-1">
              <i class="fa fa-briefcase text-warning"></i> {{ 'galleryDashboard.turnoverRate' | transloco }}
            </span>
            <div>
              <div class="fw-bold">
                {{ 'galleryDashboard.month' | transloco }} {{galleryDashboardData.TurnoverRate30Days}} {{ 'galleryDashboard.days' | transloco }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  second row -->
    <div class="row g-0 mt-3 dsGalleryInfoDiv">
      <!-- Table Section -->
      <div class="col-8 dsGalleryData">
        <div class="d-flex flex-column">
          <div class="table-responsive mt-3 mb-2">
            <!-- PrimeNG Table for Connected Artists -->
            @if (galleryDashboardData != undefined && galleryDashboardData.ConnectedArtist != undefined) {
              <p-table #dt [value]="galleryDashboardData.ConnectedArtist" dataKey="Id" [rowHover]="true"
                styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="['Name', 'PhoneNumber']"
                [paginator]="galleryDashboardData.ConnectedArtist!.length > 10" [rows]="10" [reorderableColumns]="true"
                [resizableColumns]="false" selectionMode="single">
                <!-- Table Caption Template -->
                <ng-template pTemplate="caption">
                  <div class="table-header">
                    <div class="d-flex justify-content-between align-items-center">
                      {{ 'galleryDashboard.connectedArtists' | transloco }}
                      <div
                        class="searchbox rounded-3 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                        <button type="button"
                          class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                          <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                        </button>
                        <input type="text" size="35"
                          class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                          (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'galleryDashboard.search' | transloco" />
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <!-- Header Template -->
                  <ng-template pTemplate="header" let-rowIndex="rowIndex" let-rowData>
                    <tr>
                      <th [pSortableColumn]="'Name'" style="min-width: 230px;">{{ 'galleryDashboard.name' | transloco }} <p-sortIcon
                      [field]="'Name'"></p-sortIcon></th>
                      <th [pSortableColumn]="'TotalConsignment'">{{ 'galleryDashboard.consignments' | transloco }}
                        <p-sortIcon [field]="'TotalConsignment'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'TotalArtworks'">{{ 'galleryDashboard.artworks' | transloco }}
                        <p-sortIcon [field]="'TotalArtworks'"></p-sortIcon>
                      </th>
                      <!--Total artworks sold-->
                      <th [pSortableColumn]="'TotalArtworksSold'" style="width: 100px;">{{ 'galleryDashboard.sales' | transloco }}
                        <p-sortIcon [field]="'TotalArtworksSold'"></p-sortIcon>
                      </th>
                      <!--Total value from those sales-->
                      <th [pSortableColumn]="'SalesValue'" style="width: 120px;">{{ 'galleryDashboard.value' | transloco }}
                        <p-sortIcon [field]="'SalesValue'"></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'ArtistTurnoverRateInDays'" style="width: 100px;">{{ 'galleryDashboard.turnover' | transloco }}
                        <p-sortIcon [field]="'ArtistTurnoverRateInDays'"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <!-- Body Template -->
                  <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
                    <tr>
                      <td>
                        <div class="form-group align-items-center d-flex">
                          <img [src]="rowData.Img ? rowData.Img : 'assets/images/No-Image.png'" class="roundedImages" />
                          <div class="ms-2">
                            <a href="javascript:void(0);" [routerLink]="['/artist', rowData.Id]">{{rowData.Name}}</a>
                            <div class="d-flex justify-content-start align-items-center ">
                              <a href="mailto:{{rowData.Email}}" target="_blank">
                                <i class="fa fa-at text-muted"></i>
                              </a>
                              @if (rowData.FacebookLink) {
                                <a href="{{rowData.FacebookLink}}" target="_blank">
                                  <i class="fa fa-facebook ms-2 text-muted"></i>
                                </a>
                              }
                              @if (rowData.InstagramLink) {
                                <a href="{{rowData.InstagramLink}}" target="_blank">
                                  <i class="fa fa-instagram ms-2 text-muted"></i>
                                </a>
                              }
                              @if (rowData.LinkedinLink) {
                                <a href="{{rowData.LinkedinLink}}" target="_blank">
                                  <i class="fa fa-linkedin ms-2 text-muted"></i>
                                </a>
                              }
                              @if (rowData.Website) {
                                <a href="{{rowData.Website}}" target="_blank">
                                  <i class="fa fa-globe ms-2 text-muted"></i>
                                </a>
                              }
                            </div>
                          </div>
                        </div>
                      </td>
                      <td> {{rowData.TotalConsignment}}</td>
                      <td> {{rowData.TotalArtworks}}</td>
                      <td> {{rowData.TotalArtworksSold}}</td>
                      <td> {{rowData.SalesValue | currency:'USD':'symbol':'1.2-2'}}</td>
                      <td> @if (rowData.ArtistTurnoverRateInDays) {
                        <span>{{ 'galleryDashboard.daysCount' | transloco: { count: rowData.ArtistTurnoverRateInDays } }}</span>
                      }
                    </td>
                  </tr>
                </ng-template>
                <!-- Empty Message Template -->
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="6">
                      <div class="text-center">{{ 'galleryDashboard.noRecordsFound' | transloco }}</div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            }
          </div>
          <!-- Chart Section -->
          <div class="border tab-view">
            <ng-container >
              @if (gallerySalesDataLoaded) {
                <p-tabView    (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
                  @for (item of galleryDashboardData.GallerySalesChartData; track item; let i = $index) {
                    <p-tabPanel [header]="item.SeriesName" >
                      <gallery-insights-charts [insightsSeriesData]="item" [selectedTabIndex]="selectedTabIndex"></gallery-insights-charts>
                    </p-tabPanel>
                  }
                </p-tabView>
              }
            </ng-container>
          </div>

          <div class="d-flex flex-row justify-content-between mt-4 statistics">
            <!-- Art Type Card -->
            <p-panel [header]="'galleryDashboard.topArtTypes' | transloco" [toggleable]="false">
              <!-- Check if BestPerformingArtTypeData has data -->
              @if (galleryDashboardData.BestPerformingArtTypeData && galleryDashboardData.BestPerformingArtTypeData!.length > 0) {
                <div class="d-flex flex-column justify-content-start align-items-between">
                  <!-- Loop through BestPerformingArtTypeData for progress bars -->
                  @for (item of galleryDashboardData.BestPerformingArtTypeData; track item) {
                    <div class="d-flex justify-content-between align-items-center mb-2"
                      >
                      <div class="text-uppercase w-100 percentageTitle">{{ item.ArtTypeName }}</div>
                      <div class="mx-2" style="width: 100px !important; text-align: right">
                        <div class="progress-bar justify-content-end">
                          <div class="progress" role="progressbar" [style.width.%]="item.PercentageOfTotal"
                            [ngClass]="item.ColorClassBasedOnPercentage">
                            <div class="progress-bar progress-bar-striped"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <!-- If BestPerformingArtTypeData is empty, display a message -->
              @if (!galleryDashboardData.BestPerformingArtTypeData || galleryDashboardData.BestPerformingArtTypeData.length === 0) {
                <div
                  class="text-center mt-2">
                  {{ 'galleryDashboard.noDataAvailable' | transloco }}
                </div>
              }
            </p-panel>


            <!-- Top Selling Artist Card -->
            <div class="card d-flex justify-content-center h-100 w-100 ms-2">
              <p-panel [header]="'galleryDashboard.topSellingArtists' | transloco" [toggleable]="false">
                <!-- Check if BestPerformingArtistData has data -->
                @if (galleryDashboardData.BestPerformingArtistData && galleryDashboardData.BestPerformingArtistData.length > 0) {
                  <!-- Loop through BestPerformingArtistData for progress bars -->
                  <div class="d-flex flex-column justify-content-start align-items-between">
                    @for (item of galleryDashboardData.BestPerformingArtistData; track item) {
                      <div class="d-flex justify-content-between align-items-center mb-2"
                        >
                        <div class="text-uppercase w-100 percentageTitle">
                          {{ item.ArtistName }}
                        </div>
                        <div class="mx-2" style="width: 100px !important; text-align: right">
                          <div class="progress-bar justify-content-end">
                            <div class="progress" role="progressbar" [style.width.%]="item.PercentageOfTotal"
                              [ngClass]="item.ColorClassBasedOnPercentage">
                              <div class="progress-bar progress-bar-striped"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- If BestPerformingArtistData is empty, display a message -->
                @if (!galleryDashboardData.BestPerformingArtistData || galleryDashboardData.BestPerformingArtistData.length === 0) {
                  <div
                    class="text-center mt-2">
                    {{ 'galleryDashboard.noDataFound' | transloco }}
                  </div>
                }
              </p-panel>
            </div>

            <!-- Fastest Turnover Artists -->
            <div class="card d-flex justify-content-center h-100 w-100 ms-2">
              <p-panel [header]="'galleryDashboard.fastestTurnoverArtists' | transloco" [toggleable]="false">
                <!-- Check if BestPerformingTurnoverRateData has data -->
                @if (galleryDashboardData.BestPerformingTurnoverRateData && galleryDashboardData.BestPerformingTurnoverRateData.length > 0) {
                  <!-- Loop through BestPerformingTurnoverRateData for progress bars -->
                  <div class="d-flex flex-column justify-content-start align-items-between">
                    @for (item of galleryDashboardData.BestPerformingTurnoverRateData; track item) {
                      <div class="d-flex justify-content-between align-items-center mb-2"
                        >
                        <div class="text-uppercase w-100 percentageTitle">{{ item.ArtistName }}</div>
                        <div class="mx-2" style="width: 100px !important; text-align: right">
                          @if (item.AverageTurnoverDays !== undefined) {
                            <div class="progress-bar justify-content-end">
                              <div class="progress" role="progressbar"
                                [style.width]="getProgressBarWidth(item.AverageTurnoverDays)"
                                [ngClass]="getProgressBarColorClass(item.AverageTurnoverDays)">
                                <div class="progress-bar progress-bar-striped"></div>
                              </div>
                            </div>
                          }
                          @if (item.AverageTurnoverDays === undefined) {
                            <div class="text-center mt-2">
                              {{ 'galleryDashboard.turnoverRateNotFound' | transloco }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- If BestPerformingTurnoverRateData is empty, display a message -->
                @if (!galleryDashboardData.BestPerformingTurnoverRateData || galleryDashboardData.BestPerformingTurnoverRateData.length === 0) {
                  <div
                    class="text-center mt-2">
                    {{ 'galleryDashboard.noDataFound' | transloco }}
                  </div>
                }
              </p-panel>
            </div>
          </div>

          <!-- Stock Report Section -->
          <div class="mt-4">
            <p-table #stockDt [value]="galleryDashboardData.GalleryStockReports" dataKey="Id" [rowHover]="true"
              [rowHover]="true" styleClass="p-datatable-gridlines p-datatable-striped"
              [globalFilterFields]="['Name', 'ArtistName', 'PhoneNumber']" [reorderableColumns]="true"
              [resizableColumns]="false" selectionMode="single">
              <ng-template pTemplate="caption">
                <div class="table-header">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="flex-column">
                      <div class="fw-bold"> {{ 'galleryDashboard.stockReport' | transloco }}</div>
                      <div class="text-small text-muted">
                        {{ 'galleryDashboard.totalItemsInStock' | transloco: { count: galleryDashboardData.TotalItemsInStock } }}
                      </div>
                    </div>
                    <div
                      class="searchbox rounded-3 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                      <button type="button"
                        class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                        <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                      </button>
                      <input type="text" size="25"
                        class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                        (input)="stockDt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'galleryDashboard.search' | transloco" />
                      </div>
                    </div>
                  </div>
                </ng-template>
                <!-- Header Template -->
                <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
                  <tr>
                    <th [pSortableColumn]="'Name'"> {{ 'galleryDashboard.products' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>

                    <th style="width: 200px;" [pSortableColumn]="'ArtistName'"> {{ 'galleryDashboard.artist' | transloco }} <p-sortIcon
                    [field]="'ArtistName'"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'SerialNumber'"> {{ 'galleryDashboard.serialNumber' | transloco }} <p-sortIcon [field]="'SerialNumber'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'CreatedDate'"> {{ 'galleryDashboard.date' | transloco }} <p-sortIcon [field]="'CreatedDate'"></p-sortIcon></th>
                <th [pSortableColumn]="'Price'"> {{ 'galleryDashboard.price' | transloco }} <p-sortIcon [field]="'Price'"></p-sortIcon></th>
              </tr>
            </ng-template>
            <!-- Body Template -->
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
              <tr class="cursor-pointer">
                <td>
                  <div class="form-group align-items-center">
                    <img [src]="rowData.ProductImgUrl ? rowData.ProductImgUrl : 'assets/images/No-Image.png'" class="roundedImages" />
                    <span class="ms-1">
                      <a href="javascript:void(0);" [routerLink]="['/', rowData.Id, 'artworks', rowData.ProductId]">{{rowData.Name}}</a>                      </span>
                    </div>
                  </td>

                  <td>
                    <div class="form-group align-items-center">
                      <!-- <img [src]="rowData.Img ? rowData.Img : 'assets/images/No-Image.png'" class="roundedImages" /> -->
                      <span class="ms-1">
                        <a href="javascript:void(0);" [routerLink]="['/artist', rowData.Id]">{{rowData.ArtistName}}</a>
                      </span>
                    </div>
                  </td>
                  <td>{{ rowData.SerialNumber }}</td>
                  <td>{{ rowData.CreatedDate | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ rowData.Price | currency:'USD':'symbol':'1.2-2'}}</td>
                </tr>
              </ng-template>
              <!-- Empty message template -->
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="5">
                    <div class="text-center">{{ 'galleryDashboard.noArtworksFound' | transloco }}</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="row">
            <div class="col-8">
              <div class="mt-3">
                <!-- Consignment Approvals Pending Panel -->
                @if (galleryDashboardData != undefined && galleryDashboardData.ConsignmentApprovalPending != undefined) {
                  <p-table #consignmentApprovalPendingDt [value]="galleryDashboardData.ConsignmentApprovalPending"
                    dataKey="Id" [rowHover]="true" styleClass="p-datatable-gridlines p-datatable-striped"
                    [globalFilterFields]="['Name', 'PhoneNumber', 'ArtistName']"
                    [paginator]="galleryDashboardData.ConsignmentApprovalPending.length > 10" [rows]="10"
                    [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
                    <ng-template pTemplate="caption">
                      <div class="table-header">
                        <div class="d-flex justify-content-between align-items-center">
                          {{ 'galleryDashboard.consignmentApprovalsPending' | transloco }}
                          <div
                            class="searchbox rounded-3 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                            <button type="button"
                              class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                              <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                            </button>
                            <input type="text" size="35"
                              class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                              (input)="consignmentApprovalPendingDt.filterGlobal($any($event.target).value, 'contains')"
                              [placeholder]="'galleryDashboard.search' | transloco" />
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="header">
                        <tr class="table-row-no-border">
                          <th>{{ 'galleryDashboard.consignment' | transloco }}</th>
                          <th>{{ 'galleryDashboard.artist' | transloco }}</th>
                          <th>{{ 'galleryDashboard.received' | transloco }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-product>
                        <tr class="table-row-no-border">
                          <td>
                            <div>
                              <a href="javascript:void(0);" [routerLink]="['/view-consignments']">{{product.Name}}
                                {{ 'galleryDashboard.itemsCount' | transloco: { count: product.NumberOfConsignmentProducts } }}
                              </a>
                            </div>
                          </td>
                          <td>
                            <a href="javascript:void(0);" [routerLink]="['/artist', product.Id]">{{product.ArtistName}}</a>
                            <div class="text-muted small">{{ product.PhoneNumber }}</div>
                          </td>
                          <td>{{ product.CreatedDate | date: 'yyyy-MM-dd' }}</td>
                        </tr>
                      </ng-template>
                      <!-- Empty message template -->
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td [attr.colspan]="3">
                            <div class="text-center">{{ 'galleryDashboard.noConsignmentsFound' | transloco }}</div>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  }
                </div>
                <div class="mt-3">
                  @if (galleryDashboardData != undefined && galleryDashboardData.IncomingGalleryConnectionRequest != undefined) {
                    <!-- Incoming Connection Request Table -->
                    <p-table [value]="galleryDashboardData.IncomingGalleryConnectionRequest" dataKey="Id" [rowHover]="true"
                      styleClass="p-datatable-gridlines p-datatable-striped" [globalFilterFields]="['Name']"
                      [paginator]="galleryDashboardData.IncomingGalleryConnectionRequest.length > 10" [rows]="10"
                      [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
                      <ng-template pTemplate="caption">
                        <div class="table-header">
                          <div class="d-flex justify-content-between align-items-center py-2">
                            {{ 'galleryDashboard.incomingConnectionRequest' | transloco }}
                          </div>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="header">
                        <tr class="table-row-no-border">
                          <th>{{ 'galleryDashboard.name' | transloco }}</th>
                          <th>{{ 'galleryDashboard.invitationDate' | transloco }}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-request>
                        <tr class="table-row-no-border">
                          <td>
                            <div class="d-flex align-items-center">
                              <img [src]="request.ImgUrl ? request.ImgUrl : 'assets/images/No-Image.png'"
                                class="roundedImages me-3" />
                                <div>
                                  <div class="mb-1">{{request.Name}}</div>
                                  <a href="javascript:void(0);">{{request.Email}}</a>
                                </div>
                              </div>
                            </td>
                            <td>
                              {{request.RequestedDate | date: 'dd/MM/yyyy'}}
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td [attr.colspan]="2">
                              <div class="text-center">{{ 'galleryDashboard.noConnectionRequestsFound' | transloco }}</div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    }
                  </div>
                </div>
                <div class="col-4">
                  <div class="mt-3">
                    @if (galleryDashboardData != undefined && galleryDashboardData.ProductRequestPending != undefined) {
                      <!-- Product Requests Pending Table -->
                      <p-table #productRequestsPending [value]="galleryDashboardData.ProductRequestPending" dataKey="Image"
                        [rowHover]="true" styleClass="p-datatable-gridlines p-datatable-striped"
                        [globalFilterFields]="['Name', 'ArtistName', 'PhoneNumber']"
                        [paginator]="galleryDashboardData.ProductRequestPending.length > 10" [rows]="10"
                        [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
                        <ng-template pTemplate="caption">
                          <div class="table-header">
                            <div class="d-flex justify-content-between align-items-center py-2">
                              {{ 'galleryDashboard.productRequestsPending' | transloco }}
                            </div>
                          </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                          <tr class="table-row-no-border">
                            <th>{{ 'galleryDashboard.product' | transloco }}</th>
                            <!-- <th>Artist</th> -->
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                          <tr class="table-row-no-border">
                            <td>
                              <div class="d-flex align-items-center">
                                <img [src]="product.Img ? product.Img : 'assets/images/No-Image.png'"
                                  class="roundedImages me-3" />
                                  <div>
                                    <div class="mb-1">{{product.Name}}</div>
                                    <div>
                                      <a href="javascript:void(0);"
                                      [routerLink]="['/artist', product.ArtistId]">{{product.ArtistName}}</a>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td [attr.colspan]="2">
                                <div class="text-center">{{ 'galleryDashboard.noProductRequestsFound' | transloco }}</div>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Side Section -->
            <div class="dsGalleryItems col-4 mt-2">
              <div class="d-flex flex-column px-2">
                <div class="fw-bold mx-2">{{ 'galleryDashboard.newProducts' | transloco }}</div>
                <div class=" mb-3">
                  <!-- Tile -->
                  <!-- <p-overlayPanel #op>
                  <div class="d-flex  mb-2 cursor-pointer" *ngIf="hoveredProduct">
                    <img [src]="hoveredProduct.Img ? hoveredProduct.Img : 'assets/images/No-Image.png'"
                      class="custom-img rounded-cube border cursor-pointer" alt="Product Image"
                      style="width: 110px; height: 110px; object-fit: cover; border-radius: 15px; margin: 0; padding: 0;">
                      <div class="d-flex flex-column ms-2 w-100">
                        <div class="text-uppercase fw-bold mb-2 ellipsis">{{hoveredProduct.Name}}</div>
                        <div class="d-flex flex-column justify-content-between small">
                          <div class="d-flex align-items-center" *ngIf="hoveredProduct.ArtTypeName">
                            <div class=" fw-semibold">ART TYPE: </div>
                            <div class="ms-2">{{hoveredProduct.ArtTypeName}}</div>
                          </div>
                          <div class="d-flex align-items-center" *ngIf="hoveredProduct.AcceptedDate">
                            <div class=" fw-semibold">ACCEPTED: </div>
                            <div class="ms-2">{{hoveredProduct.AcceptedDate | date: 'dd/MM/yyyy' }}
                              <ng-container *ngIf="hoveredProduct.AcceptedDaysAgo">({{hoveredProduct.AcceptedDaysAgo}}
                              days)</ng-container>
                            </div>
                          </div>
                          <div class="d-flex align-items-center" *ngIf="hoveredProduct.Price">
                            <div class=" fw-semibold">PRICE: </div>
                            <div class="ms-2">{{hoveredProduct.Price | currency:'USD':'symbol':'1.2-2'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-overlayPanel> -->
                  <!-- Card -->
                  @if (galleryDashboardData.NewProductsAdded?.length == 0) {
                    <div class="d-flex justify-content-center">
                      <span>{{ 'galleryDashboard.noProductsFound' | transloco }}</span>
                    </div>
                  }
                  <div class="row my-2 g-0 border-bottom mb-3 dsItemGrid">
                    @for (product of galleryDashboardData.NewProductsAdded; track product) {
                      <div class="dsCards col-6 recent-sales">
                        <div class="card border shadow mb-3 cursor-pointer position-relative"
                          (click)="navigateToProduct(product)">
                          <img [src]="product.Img ? product.Img : 'assets/images/No-Image.png'"
                            class="w-100 h-100 card-img-top rounded-cube cursor-pointer" [alt]="'galleryDashboard.productImage' | transloco">
                            <div class="card-body">
                              <div class="card-title fw-bold">{{product.Name}}</div>
                              @if (product.Price) {
                                <div>
                                  <span class="card-price fw-bold">{{ 'galleryDashboard.priceLabel' | transloco }}</span> {{product.Price | currency:'USD':'symbol':'1.2-2'}}
                                </div>
                              }
                            </div>
                            <!-- Icon positioned to the top right corner -->
                            <i class="fa fa-info-circle text-end fs-3 me-1 py-2 position-absolute top-0 end-0 cursor-pointer"
                              [pTooltip]="'galleryDashboard.seeMoreDetails' | transloco"
                              tooltipPosition="left"
                              (click)="showProductDialog(product); $event.stopPropagation()">
                            </i>
                          </div>
                        </div>
                      }
                    </div>
                  </div>

                  <div class="fw-bold mx-2">{{ 'galleryDashboard.recentSales' | transloco }}</div>
                  <div class="mb-3">
                    <div class="row my-2 g-0">
                      <div class="row my-2 g-0 border-bottom mb-3 dsItemGrid">
                        @if (galleryDashboardData.RecentSales?.length == 0) {
                          <div class="d-flex justify-content-center">
                            <span>{{ 'galleryDashboard.noProductsFound' | transloco }}</span>
                          </div>
                        }
                        @for (product of galleryDashboardData.RecentSales; track product) {
                          <div class="dsCards col-6 recent-sales">
                            <div class="d-flex flex-column border text-center cursor-pointer recent-sales"
                              (mouseenter)="showOverlayPanel($event, product)" (click)="navigateToProduct(product)"
                              (mouseleave)="hideDialog()">
                              <div class="card justify-content-center">
                                <img [src]="product.Img ? product.Img : 'assets/images/No-Image.png'"
                                  class="w-100 h-100 card-img-top rounded-cube cursor-pointer" [alt]="'galleryDashboard.productImage' | transloco">
                                </div>
                                <div class="card-body">
                                  <div class="card-title fw-bold">{{product.Name}}</div>
                                  @if (product.Price) {
                                    <div>
                                      <span class="card-price fw-bold">{{ 'galleryDashboard.priceLabel' | transloco }}</span> {{product.Price |
                                      currency:'USD':'symbol':'1.2-2'}}
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p-dialog [header]="'galleryDashboard.productDetail' | transloco" [(visible)]="isProductDetailDialogVisible" [modal]="true"
              [style]="{ 'width': '500px' }" (onHide)="hideDialog()">
              @if (selectedProduct) {
                <div class="d-flex" >
                  <div class="custom-img-container" >
                    <img [src]="selectedProduct.Img ? selectedProduct.Img : 'assets/images/No-Image.png'"
                      class="custom-img rounded-cube border" [alt]="'galleryDashboard.productImage' | transloco" (click)="naviGateToViewPage(selectedProduct)">
                    </div>
                    <div class="d-flex flex-column ms-2 text-uppercase">
                      @if (selectedProduct.Name) {
                        <div class="fw-bold fs-5 cursor-pointer" (click)="naviGateToViewPage(selectedProduct)">
                          {{ selectedProduct.Name }}
                        </div>
                      }
                      <div class="mt-2">
                        @if (selectedProduct.Price) {
                          <div class="d-flex align-items-center">
                            <div class="fw-semibold text-uppercase">{{ 'galleryDashboard.priceColon' | transloco }} </div>
                            <div class="ms-2">{{ selectedProduct.Price | currency:'USD':'symbol':'1.2-2' }}</div>
                          </div>
                        }
                        @if (selectedProduct.ArtTypeName) {
                          <div class="d-flex align-items-center">
                            <div class="fw-semibold text-uppercase">{{ 'galleryDashboard.artType' | transloco }} </div>
                            <div class="ms-2">{{ selectedProduct.ArtTypeName }}</div>
                          </div>
                        }
                        @if (selectedProduct.AcceptedDaysAgo) {
                          <div class="d-flex flex-row justify-content-between">
                            <div class="d-flex align-items-center cursor-pointer">
                              <div class="fw-semibold text-uppercase">{{ 'galleryDashboard.accepted' | transloco }} </div>
                              <div class="ms-1 text-title">{{ dispatchedDaysAgo(selectedProduct.AcceptedDaysAgo) | date: 'MM/dd/yyyy' }}
                                @if (isToday(dispatchedDaysAgo(selectedProduct.AcceptedDaysAgo))) {
                                  {{ 'galleryDashboard.today' | transloco }}
                                }
                                @if (!isToday(dispatchedDaysAgo(selectedProduct.AcceptedDaysAgo))) {
                                  {{ 'galleryDashboard.daysAgo' | transloco: { count: selectedProduct.AcceptedDaysAgo } }}
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </p-dialog>